<template>
	<core-layout-content full>
		<core-layout-headline-and-actions>
			<template slot="headline">
				<div class="flex xs-middle">
					<!-- Back button -->
					<j-button
						size="small"
						type="secondary"
						@click="$router.back()"
						class="mr2"
					>
						<crm-icon name="back" size="normal" color="c5" class="mr1" />
					</j-button>
				</div>
			</template>
			<template slot="actions">
				<!-- <j-button @click="handleUpdate">{{ $t("update") }}</j-button> -->
			</template>
		</core-layout-headline-and-actions>

		<j-card class=" xs-12 bg5 p4">
			<!-- Name -->
			<div class="fs4 fw7 c6 mb2">{{ $t("name") }}</div>
			<j-base-input-text v-model="name" class="xs-12 mb4" />
			<!-- Description -->
			<div class="fs4 fw7 c6 mb2">{{ $t("description") }}</div>
			<j-base-input-long-text v-model="description" class="mb4" />
			<!-- Graphql Query -->
			<div class="fs4 fw7 c6 mb2">{{ $t("graphql_query") }}</div>
			<core-monaco-editor
				language="graphql"
				v-model="graphQlQuery"
				class="mb8"
			/>
			<!-- Engine -->
			<p class="mb2 fs3 fw7 c6">{{ $t("engine") }}</p>
			<j-base-select
				class="mb4"
				v-model="selectedEngine"
				:options="engineOptions"
			/>
			<!-- Filekey -->

			<div class="flex xs-between xs-middle mb2">
				<p class="fs3 fw7 c6">{{ $t("file") }}</p>
				<j-button
					size="small"
					type="tertiary"
					@click="$modal.show('uploadFile')"
					>{{ $t("upload_file") }}</j-button
				>
			</div>
			<j-base-select v-model="fileKey" :options="fileListing" class="mb4" />

			<!-- Update -->
			<div class="flex xs-right">
				<j-button @click="handleUpdate">{{ $t("update") }}</j-button>
			</div>
		</j-card>

		<j-card class="xs-12 p4 bg5 mt8" v-if="selectedEngine === 'excel'">
			<excel-engine-fields :payload="fetchedTemplate" />
		</j-card>

		<core-modal name="uploadFile" :headline="$t('upload_file')">
			<core-files-upload
				id
				filesOf="template"
				:supportedFileTypes="['xlsx']"
				@upload:finished="fetchFileListing"
			/>
		</core-modal>
	</core-layout-content>
</template>

<script>
import CrmIcon from "@/components/CrmIcon"
import CoreLayoutContent from "@/modules/core/components/CoreLayoutContent.vue"
import CoreLayoutHeadlineAndActions from "@/modules/core/components/CoreLayoutHeadlineAndActions.vue"
import JButton from "@/components/JButton"
import CoreMonacoEditor from "@/modules/core/components/CoreMonacoEditor"
import JBaseInputText from "@/components/JBaseInputText"
import JBaseInputLongText from "@/components/JBaseInputLongText"
import JBaseSelect from "@/components/JBaseSelect/"
import JCard from "@/components/JCard/"
import CoreFilesUpload from "@/modules/core/components/CoreFilesUpload"
import CoreModal from "@/modules/core/components/CoreModal"

import ExcelEngineFields from "../components/FunctionTemplate/ExcelEngineFields"

import api from "@/api/gql.js"
import { gql } from "@/api/utils.js"

export default {
	components: {
		CrmIcon,
		CoreLayoutContent,
		CoreLayoutHeadlineAndActions,
		JButton,
		CoreMonacoEditor,
		JBaseInputText,
		JBaseInputLongText,
		JBaseSelect,
		JCard,
		CoreFilesUpload,
		CoreModal,

		ExcelEngineFields
	},

	data() {
		return {
			fileKey: null,
			fileListing: [],
			fetchedTemplate: null,
			name: null,
			description: null,
			engineOptions: [{ name: this.$t("excel"), value: "excel" }],
			selectedEngine: null,
			graphQlQuery: null
		}
	},

	methods: {
		async fetchFunctionTemplate() {
			const query = gql`
				query templates($where: templateWhereInput!) {
					templates(where: $where) {
						list {
							... on functionTemplate {
								id
								name
								description
								fileKey
								graphQlQuery
								inputs {
									id
									name
									var
									liquid
								}
								outputs {
									id
									name
									var
								}
								engine {
									runTime
									name
								}
							}
						}
					}
				}
			`
			const variables = {
				where: {
					id: this.$route.params.id
				}
			}

			const res = await api({ query, variables })
			this.fetchedTemplate = res?.data?.templates?.list?.[0]
			this.name = this.fetchedTemplate?.name
			this.description = this.fetchedTemplate?.description
			this.fileKey = this.fetchedTemplate?.fileKey
			this.graphQlQuery = this.fetchedTemplate?.graphQlQuery
			this.selectedEngine = this.fetchedTemplate?.engine?.name
		},

		async fetchFileListing() {
			const query = gql`
				query fileListing($prefix: String, $bucketName: String) {
					fileListing(prefix: $prefix, bucketName: $bucketName) {
						commonPrefixes
						objectSummaries {
							fileName
							key
						}
					}
				}
			`
			const variables = {
				prefix: "templates/",
				bucketName: this.$store.state.tenantId.replace("_", "--")
			}

			const res = await api({ query, variables })

			this.fileListing = res?.data?.fileListing?.objectSummaries
				?.map(item => ({ name: item?.fileName, value: item?.key }))
				?.filter(item => item?.value?.includes("xlsx"))
		},

		async handleUpdate() {
			const query = gql`
				mutation updateFunctionTemplate(
					$id: String!
					$input: updateFunctionTemplateInput!
				) {
					updateFunctionTemplate(id: $id, input: $input) {
						status
						errors
					}
				}
			`
			const variables = {
				id: this.$route.params.id,
				input: {
					name: this.name,
					description: this.description,
					fileKey: this.fileKey,
					graphQlQuery: this.graphQlQuery,
					engine: {
						runTime: this.selectedEngine,
						name: this.selectedEngine
					}
				}
			}

			const res = await api({ query, variables })

			if (res?.data?.updateFunctionTemplate?.status !== "success") {
				this.$store.dispatch("addMessage", {
					message: {
						type: "error",
						text:
							res?.errors ||
							res?.data?.updateFunctionTemplate?.errors ||
							res?.data?.updateFunctionTemplate?.errors_2?.message ||
							"Oops ! An error occured."
					}
				})
			} else
				this.$store.dispatch("addMessage", {
					message: {
						type: "success",
						text: this.$t("template_updated")
					}
				})

			this.fetchFunctionTemplate()
		}
	},

	computed: {
		computedName() {
			return this.fetchedTemplate?.name
		}
	},

	created() {
		this.fetchFileListing()
		this.fetchFunctionTemplate()
	}
}
</script>
